exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nfieldset {\n  border-width: 0em;\n}\n.field-checkbox input {\n  margin-left: 12px;\n  margin-bottom: 2px;\n}\n", ""]);

// exports
